import React from 'react'
import RadioButton from './RadioButton'
import DynamicColor from '../common/dynamic-color'

import { COLOR_NAME } from '../../constants'
import { clsx } from '../../utils/helper'

const RadioGroup = ({
    label,
    value,
    className = '',
    large,
    list,
    ...props
}) => {
    return (
        <div className={clsx(['app-radio-group', large && 'large', className])}>
            {label && (
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="mb-2 app-radio-group__label"
                >
                    {label}
                </DynamicColor>
            )}

            <div className="app-radio-group__list">
                {list.map((el, index) => (
                    <RadioButton
                        key={index}
                        checked={value === el.value}
                        {...el}
                        {...props}
                    />
                ))}
            </div>
        </div>
    )
}

export default RadioGroup
